import React, { useState } from "react";
import CookiesBanner from "./banner";
import Popup from "./popup";
import { useTranslation } from "react-i18next";

const Cookies = (props) => {
  const { t } = useTranslation();
  const [showCookiesPopup, setshowCookiesPopup] = useState(false);

  const handleOpenPopup = () => {
    setshowCookiesPopup((prevState) => !prevState);
  };

  return (
    <React.Fragment>
      <Popup
        size={"lg"}
        open={showCookiesPopup}
        header={t("policies.cookies.popupHeader")}
        onClose={handleOpenPopup}
        actionAccept={props.acceptCookies}
        actionClose={handleOpenPopup}
      >
        {
          // mockup content for demonstration purposes only that should be replaced with the actual content from the API
          t("policies.cookies.popupBody")
        }
      </Popup>
      <CookiesBanner
        acceptCookies={props.acceptCookies}
        openPopup={handleOpenPopup}
      ></CookiesBanner>
    </React.Fragment>
  );
};

export default Cookies;
